const NOTION = [
    {
        "name": "Day1.",
        "address": "https://instinctive-time-66e.notion.site/ebd/1a299e2dae38817d8ddccb6d91df8c01"
    },
    {
        "name": "Day2.",
        "address": "https://instinctive-time-66e.notion.site/ebd/d14b7ada4d8c41bba006ade4995c791f"
    },
    {
        "name": "Day3.",
        "address": "https://instinctive-time-66e.notion.site/ebd/525dd30e92ad4005a7ec8b32be7e3c26"
    },
    {
        "name": "Day4.",
        "address": "https://instinctive-time-66e.notion.site/ebd/d45ec64b7bc64d07993c3f7aa5531c53"
    },
    {
        "name": "Day5.",
        "address": "https://instinctive-time-66e.notion.site/ebd/1a299e2dae388150bd2fd0336178a6bb"
    },
    {
        "name": "Day6.",
        "address": "https://instinctive-time-66e.notion.site/ebd/4569df42c990477db731ceaa12cb7abf"
    },
    {
        "name": "Day7.",
        "address": "https://instinctive-time-66e.notion.site/ebd/1a299e2dae38813fa07ae7f1e7e4b4e9"
    },
    {
        "name": "Day8.",
        "address": "https://instinctive-time-66e.notion.site/ebd/1a299e2dae3881c4a3bbe78aa9976ee5"
    }
]

export default NOTION